/* Kunzul Channar – site behaviours: smooth scroll, reveal animations, infinite product loading */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = window.Shopify && window.Shopify.designMode;

  /* ---------------- Smooth scroll (desktop / mouse only) ---------------- */
  var lenis = null;
  function initLenis() {
    if (reduceMotion || designMode || typeof window.Lenis !== 'function') return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    var PREVENT = 'cart-drawer, .kc-drawer, .kc-filters, .kc-search, menu-drawer, .menu-drawer, .mobile-facets, .facets, .kc-toolbar__cats, .drawer, details-modal, .quantity-popover-container, predictive-search';
    function tagPrevent(scope) { Array.prototype.forEach.call((scope || document).querySelectorAll(PREVENT), function (el) { el.setAttribute('data-lenis-prevent', ''); }); }
    tagPrevent(document);
    lenis = new window.Lenis({ duration: 1.1, smoothWheel: true, wheelMultiplier: 1 });
    window.kcLenis = lenis;
    function raf(t) { lenis.raf(t); requestAnimationFrame(raf); }
    requestAnimationFrame(raf);

    // Pause smooth scroll while any drawer / modal locks the page
    function sync() {
      var html = document.documentElement, body = document.body;
      var locked = html.style.overflow === 'hidden' || body.classList.contains('overflow-hidden') ||
        body.classList.contains('overflow-hidden-mobile') || body.classList.contains('overflow-hidden-tablet') ||
        body.classList.contains('overflow-hidden-desktop') || !!document.querySelector('.kc-drawer.is-open, .kc-filters.is-open, cart-drawer.active');
      if (locked) lenis.stop(); else lenis.start();
    }
    var mo = new MutationObserver(sync);
    mo.observe(document.documentElement, { attributes: true, attributeFilter: ['style', 'class'] });
    mo.observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
    document.addEventListener('click', function () { setTimeout(sync, 50); setTimeout(sync, 450); });

    // Smooth in-page anchor links
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a || a.getAttribute('href').length < 2) return;
      var target = document.querySelector(a.getAttribute('href'));
      if (!target) return;
      e.preventDefault();
      lenis.scrollTo(target, { offset: -90 });
    });
  }

  /* ---------------- Reveal on scroll ---------------- */
  var REVEAL = [
    'main .kc-h1', 'main .kc-body', 'main .kc-link',
    'main .kc-card', 'main .kc-feature__img', 'main .kc-single__media', 'main .kc-gallery__item',
    'main .kc-split__item', 'main .kc-promo__media', 'main .kc-about__row', 'main .kc-banner',
    'main .kc-pill', 'footer .kc-footer__logo', '.kc-footer__cols'
  ].join(',');
  var io = null;
  function markReveal(scope) {
    if (reduceMotion || designMode || !('IntersectionObserver' in window)) return;
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var t = en.target;
          t.classList.add('kc-in');
          io.unobserve(t);
          setTimeout(function () { t.style.transitionDelay = ''; }, 1200);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    }
    var els = (scope || document).querySelectorAll(REVEAL);
    var perRow = {};
    Array.prototype.forEach.call(els, function (el) {
      if (el.classList.contains('kc-reveal')) return;
      if (el.closest('.kc-pdp, .kc-header, .kc-drawer, cart-drawer, .kc-hero, .kc-reveal')) return;
      el.classList.add('kc-reveal');
      // small stagger for items sharing the same parent (cards in a grid)
      var p = el.parentElement;
      var key = p ? (p.__kcId || (p.__kcId = Math.random().toString(36).slice(2))) : 'x';
      perRow[key] = (perRow[key] || 0) + 1;
      el.style.transitionDelay = Math.min((perRow[key] - 1) % 4, 3) * 70 + 'ms';
      io.observe(el);
    });
  }

  /* ---------------- Infinite product loading (replaces pagination) ---------------- */
  function findNext(doc) {
    var p = doc.querySelector('[data-kc-pagination], .pagination-wrapper');
    if (!p) return null;
    var curEl = p.querySelector('[aria-current="page"], .is-current');
    var cur = curEl ? parseInt(curEl.textContent, 10) || 1 : 1;
    var links = p.querySelectorAll('a[href]');
    for (var i = 0; i < links.length; i++) {
      var u = new URL(links[i].getAttribute('href'), window.location.href);
      if (parseInt(u.searchParams.get('page') || '1', 10) === cur + 1) return u.href;
    }
    return null;
  }
  function initInfinite() {
    var gridSel = '[data-kc-infinite-grid], #product-grid';
    var grid = document.querySelector(gridSel);
    var pag = document.querySelector('[data-kc-pagination], .pagination-wrapper');
    if (!grid || !pag) return;
    var next = findNext(document);
    pag.style.display = 'none';
    if (!next) return;
    var loader = document.createElement('div');
    loader.className = 'kc-loader';
    loader.setAttribute('aria-hidden', 'true');
    loader.innerHTML = '<span></span><span></span><span></span>';
    grid.parentNode.insertBefore(loader, grid.nextSibling);
    var busy = false;
    var obs = new IntersectionObserver(function (en) { if (en[0].isIntersecting) load(); }, { rootMargin: '900px 0px' });
    obs.observe(loader);
    function done() { obs.disconnect(); loader.remove(); }
    function load() {
      if (busy || !next) return;
      busy = true;
      loader.classList.add('is-loading');
      fetch(next, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var g = doc.querySelector(gridSel);
          if (g) {
            var frag = document.createDocumentFragment();
            Array.prototype.slice.call(g.children).forEach(function (c) { frag.appendChild(document.importNode(c, true)); });
            grid.appendChild(frag);
            markReveal(grid);
            if (typeof window.initializeScrollAnimationTrigger === 'function') { try { window.initializeScrollAnimationTrigger(grid); } catch (e) {} }
          }
          next = findNext(doc);
          if (!next) done();
          if (lenis) lenis.resize();
        })
        .catch(function () { pag.style.display = ''; done(); })
        .finally(function () {
          busy = false;
          loader.classList.remove('is-loading');
          // keep filling if the loader is still visible
          if (next) { var r = loader.getBoundingClientRect(); if (r.top < window.innerHeight + 900) setTimeout(load, 60); }
        });
    }
  }

  function boot() {
    initLenis();
    markReveal(document);
    initInfinite();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { markReveal(e.target); });
})();
